

export const shareView = {
    sharedBy: '分享 by '
  };
